import React, { Component } from "react";
//estilos de material design
import {
  Container,
  Avatar,
  Typography,
  TextField,
  Button,
  Grid,
  Link
} from "@material-ui/core";
//iconos de react-material-ui-design
import LockOutLineIcon from "@material-ui/icons/LockOutlined";
//recompose
import { compose } from "recompose";
//accedemos a el consumer del objeto firebase en este componente
import { consumerFirebase } from "../../server";
//accedemos a la variable startSession del archivo session/actions/sessionAction - para cambiar el comportamiento del boton de login
import { startSession } from "../../session/actions/sessionAction";
//invocamos al openMessageAction para mostrarlo en el callback.status al realizar la accion de login
import { openMessageError } from "../../session/actions/openMessageAction";
//para poder extraer el valor del dispatch necesitamos importar el StateContext del archivo session/store.js
import { StateContext } from "../../session/store";

const style = {
  paper: {
    marginTop: 9,
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: 5,
    backgroundColor: "#e53935"
  },
  form: {
    width: "100%",
    marginTop: 8
  },
  submit: {
    marginTop: 10,
    marginBottom: 10
  }
};

class Login extends Component {
  //extraemos los valores del context provider incluidos en la variable SessionContext para poder  usar sus variables globales en el buttonLogin, y en particualr poder usar el dispatch
  static contextType = StateContext;

  //definimos el estado del componente
  state = {
    firebase: null,
    usuario: {
      email: "jrg@gmail.com",
      password: "123456"
    }
  };

  //comprobar que el objeto firebase se ha modificado para camviar el objeto del estado del componente
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.firebase === prevState.firebase) {
      return null;
    }
    return {
      firebase: nextProps.firebase
    };
  }

  //guarda el texto proveniente del value
  onChangeInputs = e => {
    let usuario = Object.assign({}, this.state.usuario);
    usuario[e.target.name] = e.target.value;
    this.setState({
      usuario: usuario
    });
  };

  //submit del boton del formulario
  //implementacion standar para hacer login
  /*buttonLogin = e => {
        e.preventDefault();
        //estraemos los valores del state
        const { user, firebase } = this.state;

        //llamamos al objeto de firebase para logear al usuario en la aplicación con el email y el password
        firebase.auth
        .signInWithEmailAndPassword(user.email, user.password)
        .then(auth => {
            console.log('el login se realizo con exito');
            this.props.history.push('/');
        })
        .catch(error =>{
            console.log('sucedio un error al realizar el login', error);
        })

    }*/

  //implementacion a traves de actions y reducers
  buttonLogin = async e => {
    e.preventDefault();
    //extraemos los valores de sesion y dispatch del contexType que viene del StateContext del context provider global
    const [{ sesion }, dispatch] = this.context;

    //extraemos el objeto firebase y user del estado del componente
    const { firebase, usuario } = this.state;
    //extraemos email y password desuario del estado del componente
    const { email, password } = usuario;
    //llamamos a la funcion para iniciar sesion de /session/actions/sessionAction
    //callback es el resolve() de la llamada a la funcion startSession
    let callback = await startSession(dispatch, firebase, email, password);
    console.log(callback);
    //si es true -----
    if (callback.status) {
      this.props.history.push("/");
      //si es false -----
    } else {
      openMessageError(dispatch, {
        //openMessageReducer - para mostrar el mensaje de error
        open: true,
        //error de firebebase al llamar a la funcion startSession de sessionAction en el resolve del catch / resolve({status : false, message : error});
        message: callback.message.message
      });
    }
  };
  // metodo para recuperar la contraseña
  resetPasword = () => {
    const { firebase, usuario } = this.state;
    const [{ sesion }, dispatch] = this.context;

    firebase.auth
      .sendPasswordResetEmail(usuario.email)
      .then(success => {
        openMessageError(dispatch, {
          open: true,
          message: "email de recuperacion de contraseña enviado"
        });
      })
      .catch(error => {
        openMessageError(dispatch, {
          open: true,
          message: error.message
        });
      });
  };

  render() {
    return (
      <Container maxWidth="xs">
        <div style={style.paper}>
          <Avatar style={style.avatar}>
            <LockOutLineIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Login
          </Typography>
          <form style={style.form}>
            <TextField
              variant="outlined"
              label="Email"
              type="email"
              name="email"
              fullWidth
              margin="normal"
              onChange={this.onChangeInputs}
              value={this.state.usuario.email}
            />
            <TextField
              variant="outlined"
              label="Password"
              name="password"
              type="password"
              fullWidth
              margin="normal"
              onChange={this.onChangeInputs}
              value={this.state.usuario.password}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              style={style.submit}
              color="primary"
              onClick={this.buttonLogin}
            >
              Login...
            </Button>

            <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2" onClick={this.resetPasword}>
                  {"Olvido su contraseña"}
                </Link>
              </Grid>

              <Grid item xs>
                <Link href="/auth/registro" variant="body2">
                  {"No tienes cuenta? Registrate"}
                </Link>
              </Grid>
            </Grid>
          </form>

          <Button
            fullWidth
            type="submit"
            variant="contained"
            color="primary"
            style={style.submit}
            href="/auth/loginPhone"
          >
            Ingrese con su teléfono
          </Button>
        </div>
      </Container>
    );
  }
}

export default compose(consumerFirebase)(Login);
